/* global fetchUrl updateUrl types addFieldUrl toggleFieldUrl updateFieldUrl deleteFieldUrl states */

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SupplierPortalSettingsFields from './SupplierPortalSettingsFields';
import SupplierPortalSettingsUpdate from './SupplierPortalSettingsUpdate';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

import useApiRequest from 'Hooks/useApiRequest';
import { useToast } from 'Hooks/useToast';

import CopyIcon from 'Assets/icons/copy.svg';

export default function SupplierPortalManagementIndex(props) {
    const [settings, setSettings] = useState(null);
    const [fields, setFields] = useState([]);
    const [copied, setCopied] = useState(false);

    const toast = useToast();

    const fieldsRequest = useApiRequest({ url: props.fetchUrl });
    const fieldsMessageRequest = useApiRequest({ url: props.updateUrl });
    const { loading } = fieldsRequest;
    const { loading: updateLoading } = fieldsMessageRequest;

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        fieldsRequest.get().then((res) => {
            const { data } = res;
            setSettings(data?.settings);
            setFields(data?.settings?.fields);
        });
    };

    const updateMessage = (message) => {
        fieldsMessageRequest.put({ message }).then((res) => {
            setSettings(res.data.settings);
            toast.success($t('Message updated successfully'));
        });
    };

    const copyPortalLink = () => {
        if (!settings?.supplier_portal_url) return;
        navigator.clipboard.writeText(settings.supplier_portal_url).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div>
            {!!settings && (
                <>
                    <div className="tw-flex tw-items-center tw-justify-between tw-mb-4">
                        <h3 className="tw-text-blue tw-text-2xl tw-font-semibold">
                            {settings.type && settings.reference ? `${settings.type}: ${settings.reference}` : $t('Portal Settings')}
                        </h3>
                        {settings.supplier_portal_url && (
                            <button
                                type="button"
                                className="button secondary tw-flex tw-items-center tw-gap-2"
                                onClick={copyPortalLink}
                                title={settings.supplier_portal_url}
                            >
                                <CopyIcon className="tw-w-4 tw-h-4" />
                                {copied ? $t('Copied!') : $t('Copy Portal Link')}
                            </button>
                        )}
                    </div>
                    <SupplierPortalSettingsUpdate settings={settings} request={loading || updateLoading} updateMessage={updateMessage} />
                    <SupplierPortalSettingsFields
                        fields={fields}
                        types={props.types}
                        request={loading || updateLoading}
                        fetchData={fetchData}
                        addFieldUrl={props.addFieldUrl}
                        toggleFieldUrl={props.toggleFieldUrl}
                        updateFieldUrl={props.updateFieldUrl}
                        deleteFieldUrl={props.deleteFieldUrl}
                        states={props.states}
                    />
                </>
            )}
        </div>
    );
}

if (document.getElementById('procurementSupplierPortal')) {
    var root = document.getElementById('procurementSupplierPortal');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <SupplierPortalManagementIndex
                    fetchUrl={fetchUrl}
                    updateUrl={updateUrl}
                    types={types}
                    addFieldUrl={addFieldUrl}
                    toggleFieldUrl={toggleFieldUrl}
                    updateFieldUrl={updateFieldUrl}
                    deleteFieldUrl={deleteFieldUrl}
                    states={states}
                />
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}
